import { atom } from 'recoil';
import { Props } from './DataGrid';

const propsState = atom<Props | null>({
  key: 'props',
  default: null,
});

export default propsState;
